<template>
  <div style="background-color: #fff">
    <div style="padding: 30px 40px" class="font30">
      <span class="font_bold">{{$t("SearchTrade.SimilarProducts")}}</span>
      <span class="fontDDDDDD margin-left20 margin-right20">|</span>
      <span class="font_bold">{{ $t("SearchTrade.Numberofsimilarproducts") }}: </span
      ><span class="font_bold" style="color: #009ea7">{{
        $parent.page.total
      }}</span>
    </div>

    <div
      style="
        box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
        padding: 30px 40px;
        border-radius: 4px;
      "
    >
      <div class="cop_title flex_center_bettwen margin-bottom20">
        <span class="font30 font_bold">{{ $t("SearchTrade.ComparisonofSimilarProducts") }}</span>
        <span
          ><svg
            @click="CompareShow"
            t="1765508299915"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8415"
            width="28"
            height="28"
          >
            <path
              d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
              fill="#1A2332"
              p-id="8416"
            ></path></svg ></span>
      </div>

      <div class="cop_cont_box">
        <div class="cop_cont_cont flex_box">
          <div
            class="list title list-title contentone"
            style="border-right: 1px solid #e7eaed"
          >
            <div class="item item_active">{{ $t("SearchTrade.ProductName") }}</div>
            <div class="item">{{ $t("SearchTrade.HSCode") }}</div>
            <div class="item">{{ $t("SearchTrade.ProductDescription") }}</div>
            <div class="item">{{ $t("SearchTrade.ImportAmount") }}</div>
            <div class="item">{{ $t("SearchTrade.ExportAmount") }}</div>
            <div class="item">{{ $t("SearchTrade.TotalImportWeight") }}</div>
            <div class="item">{{ $t("SearchTrade.TotalExportWeight") }}</div>
            <div class="item">{{ $t("SearchTrade.TotalImports") }}</div>
            <div class="item">{{ $t("SearchTrade.TotalExports") }}</div>
            <div class="item">{{ $t("SearchTrade.NumberofSuppliers") }}</div>
            <div class="item">{{ $t("SearchTrade.NumberofBuyers") }}</div>
            <div class="item">{{ $t("SearchTrade.NumberofOrigin") }}</div>
            <div class="item">{{ $t("SearchTrade.NumberofDestination") }}</div>
          </div>
          <div class="list content" style="border-right: 1px solid #e7eaed">
            <div class="item item_active">
              <div
                class="line_2"
                @click="setidtwo(compObj)"
                style="font-family: 'Arial Bold'; cursor: pointer"
              >
                {{ compObj.productName }}
              </div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.hsCode }}</div>
            </div>
            <div class="item">
              <div class="line_2">
                <div class="line_2">{{ compObj.productDescription }}</div>
              </div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.totalImportAmount }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.totalExportAmount }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.totalImportWeight }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.totalExportWeight }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.totalQuantityOfImports }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.totalExportQuantity }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.numberOfSellers }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.numberOfBuyers }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj.numberOfOrigins }}</div>
            </div>

            <div class="item">
              <div class="line_2">{{ compObj.numberOfDestinations }}</div>
            </div>
          </div>
          <div class="list content" style="border-right: 1px solid #e7eaed">
            <div class="item item_active">
              <div class="cop_add">
                <div
                  class="flex_center CompanyNameActive"
                  v-show="isDelOne"
                  @click="
                    addIndex = 2;
                    CompareShow();
                  "
                >
                  <svg
                    t="1725586885335"
                    class="icon"
                    style="margin-right: 10px"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5401"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M995.84 483.84H540.16V28.16a28.16 28.16 0 1 0-56.32 0v455.68H28.16a28.16 28.16 0 0 0 0 56.32h455.68v455.68a28.16 28.16 0 1 0 56.32 0V540.16h455.68a28.16 28.16 0 1 0 0-56.32z"
                      p-id="5402"
                      fill="#1290C9"
                    ></path>
                  </svg>
                  {{ $t("SearchTrade.AddProduct") }}
                </div>
              </div>
              <div
                class="line_2"
                style="font-family: 'Arial Bold'; cursor: pointer"
                @click="setidtwo(compObj2)"
              >
                {{ compObj2.productName }}
              </div>
              <div
                class="flex_center Deletepostion"
                v-show="!isDelOne"
                style="color: #f56b6b"
                @click="(addIndex = 2), delCompany()"
              >
                <svg
                  t="1730875902586"
                  style="margin-right: 10px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="6280"
                  width="20"
                  height="20"
                >
                  <path
                    d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                    fill="#FF6A6A"
                    p-id="6281"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.hsCode }}</div>
            </div>
            <div class="item">
              <div class="line_2">
                <div class="line_2">{{ compObj2.productDescription }}</div>
              </div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.totalImportAmount }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.totalExportAmount }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.totalImportWeight }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.totalExportWeight }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.totalQuantityOfImports }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.totalExportQuantity }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.numberOfSellers }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.numberOfBuyers }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj2.numberOfOrigins }}</div>
            </div>

            <div class="item">
              <div class="line_2">{{ compObj2.numberOfDestinations }}</div>
            </div>
          </div>
          <div class="list content">
            <div class="item item_active">
              <div class="cop_add">
                <div
                  class="flex_center CompanyNameActive"
                  v-show="isDelTwo"
                  @click="
                    addIndex = 3;
                    CompareShow();
                  "
                >
                  <svg
                    t="1725586885335"
                    class="icon"
                    style="margin-right: 10px"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5401"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M995.84 483.84H540.16V28.16a28.16 28.16 0 1 0-56.32 0v455.68H28.16a28.16 28.16 0 0 0 0 56.32h455.68v455.68a28.16 28.16 0 1 0 56.32 0V540.16h455.68a28.16 28.16 0 1 0 0-56.32z"
                      p-id="5402"
                      fill="#1290C9"
                    ></path>
                  </svg>
                  {{ $t("SearchTrade.AddProduct") }}
                </div>
              </div>
              <div
                class="line_2"
                style="font-family: 'Arial Bold'; cursor: pointer"
                @click="setidtwo(compObj3)"
              >
                {{ compObj3.productName }}
              </div>
              <div
                class="flex_center Deletepostion"
                v-show="!isDelTwo"
                style="color: #f56b6b"
                @click="(addIndex = 3), delCompany()"
              >
                <svg
                  t="1730875902586"
                  style="margin-right: 10px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="6280"
                  width="20"
                  height="20"
                >
                  <path
                    d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                    fill="#FF6A6A"
                    p-id="6281"
                  ></path>
                </svg>
              </div>
            </div>

            <div class="item">
              <div class="line_2">{{ compObj3.hsCode }}</div>
            </div>
            <div class="item">
              <div class="line_2">
                <div class="line_2">{{ compObj3.productDescription }}</div>
              </div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.totalImportAmount }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.totalExportAmount }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.totalImportWeight }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.totalExportWeight }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.totalQuantityOfImports }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.totalExportQuantity }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.numberOfSellers }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.numberOfBuyers }}</div>
            </div>
            <div class="item">
              <div class="line_2">{{ compObj3.numberOfOrigins }}</div>
            </div>

            <div class="item">
              <div class="line_2">{{ compObj3.numberOfDestinations }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { searchCompany } from "@/api/searchApi.js";
import {
  getCompanyCompare,
  getCountryCollection,
  getProductCompareData,
  ordersAdd,
} from "@/api/companyApi.js";

import { getPdfAddress, getPdfPurchase, getPdfhk_pdf } from "@/api/userApi.js";
import crypto from "@/utils/crypto";
import { mixins1 } from "@/mixins/index";

export default {
  mixins: [mixins1],
  props: {
    compareList: {
      type: Array,
      default: [],
    },
  },
  watch: {
    CompareIs: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getData();
        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      compObj: {
        aaaId: "",
        CompanyName: "COSTCO WHOLESALE CORPORATION",
        CompanyNativeName: "",
        LegalStatus: [],
        LegalForm: "",
        YearsinBusiness: "",
        RegCapital: "",
        isic: "",
        IndustryDescription: "",
        Listed: "",
        NoofEmployees: "",
        Noofshareholders: "",
        Revenue: "",
        Netincome: "",
        TotalAssets: "",
        Profitmargin: "",
        Profitability: "",
        BlackList: "",
        CreditScore: "",
      },
      compObj2: {},
      compObj3: {},
      countryVal: "",
      selCountryList: [],
      enName: "",
      addIndex: 1,
      addDialog: false,
      restaurants: [],
      lastView: false,
      lastView3: false,
      isDelOne: true,
      isDelTwo: true,
      addDisabled: true,
      companyValList: [],
      page: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
      pageChild: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
      id3a: "",
      companyCountry: "",
      companyNameEn: "",
      companyNameCn: "",
      id3a3: "",
      companyCountry3: "",
      companyNameEn3: "",
      companyNameCn3: "",
      countryObj: {},
      updateDisabled: false,
      updateDisabled3: false,
      orderStatus: "",
      offlineOrderId: "",
      offlineOrderId3: "",

      seachdoudong: false,
      //国家分类
      tabCountryList: [],
      productloding: false,
      percentageerr: false,
      countryCode1: "",
      countryCode: "",
      countryName: "", //选中国家
      countryImg: "", //选中国家的国旗
      tabActiveName: "", //选择的区域
      isNotice: true, //通知高亮
      searchName: "",
      parentTable: [],
      childTable: [],
      expands: [],
      branchflag: "",
      refresh: 0,
      parentTableloding: false,
      ret: false,
    };
  },
  computed: {
    //index传值 是否翻译
    CompareIs: {
      get() {
        return this.$parent.Compare;
      },
      set() {},
    },
  },
  created() {
    this.$emit("UpdatamarkTotalList", false);
  },
  methods: {
    CompareShow() {
      this.$emit("CompareShowfalse", false);
    },
    handleSelectAll(selection) {
      if (selection.length > 1) {
        this.$refs.treeTable.clearSelection();
        this.$refs.treeTable.toggleRowSelection(selection[0]);
      }
    },
    // 全选
    handleSelectionChange(selection) {
      if (selection.length > 0) {
        this.handleSelect(selection[0]);
      }
    },
    // 国旗跳转
    gotocountry(row) {
      let routeData = this.$router.resolve({
        path: "/country?" + "&companyCountry=" + row.company_country,
      });

      window.open(routeData.href, "_blank");
    },

    // 选中国家

    async getData() {
      let compareList = this.compareList.slice(0, 3);
      compareList.map((item, index) => {
        getProductCompareData({
          hsCodes: item.hsCode,
        })
          .then((resdata) => {
            if (resdata.code == 200) {
              if (index == 0) {
                let res = resdata.data[0];
                this.compObj = {
                  hsCode: res.hsCode,
                  numberOfBuyers: res.numberOfBuyers,
                  numberOfDestinations: res.numberOfDestinations,
                  numberOfOrigins: res.numberOfOrigins,
                  // Company Legal Status
                  numberOfSellers: res.numberOfSellers,
                  productCode: res.productCode,
                  productDescription: res.productDescription,
                  productName: res.productName,
                  totalExportAmount: res.totalExportAmount,
                  totalExportQuantity: res.totalExportQuantity,
                  totalExportWeight: res.totalExportWeight,
                  totalImportAmount: res.totalImportAmount,
                  totalImportWeight: res.totalImportWeight,
                  totalQuantityOfImports: res.totalQuantityOfImports,
                };
              }
              if (index == 1) {
                let res1 = resdata.data[0];
                this.compObj2 = {
                  hsCode: res1.hsCode,
                  numberOfBuyers: res1.numberOfBuyers,
                  numberOfDestinations: res1.numberOfDestinations,
                  numberOfOrigins: res1.numberOfOrigins,
                  // Company Legal Status
                  numberOfSellers: res1.numberOfSellers,
                  productCode: res1.productCode,
                  productDescription: res1.productDescription,
                  productName: res1.productName,
                  totalExportAmount: res1.totalExportAmount,
                  totalExportQuantity: res1.totalExportQuantity,
                  totalExportWeight: res1.totalExportWeight,
                  totalImportAmount: res1.totalImportAmount,
                  totalImportWeight: res1.totalImportWeight,
                  totalQuantityOfImports: res1.totalQuantityOfImports,
                };
                this.isDelOne = false;
                this.lastView = true;
              }
              if (index == 2) {
                let res2 = resdata.data[0];
                this.compObj3 = {
                  hsCode: res2.hsCode,
                  numberOfBuyers: res2.numberOfBuyers,
                  numberOfDestinations: res2.numberOfDestinations,
                  numberOfOrigins: res2.numberOfOrigins,
                  // Company Legal Status
                  numberOfSellers: res2.numberOfSellers,
                  productCode: res2.productCode,
                  productDescription: res2.productDescription,
                  productName: res2.productName,
                  totalExportAmount: res2.totalExportAmount,
                  totalExportQuantity: res2.totalExportQuantity,
                  totalExportWeight: res2.totalExportWeight,
                  totalImportAmount: res2.totalImportAmount,
                  totalImportWeight: res2.totalImportWeight,
                  totalQuantityOfImports: res2.totalQuantityOfImports,
                };
                this.isDelTwo = false;
                this.lastView3 = true;
              }
            }
          })
          .catch((err) => {
            this.reLoginVis = String(err).includes("403");
          });
      });
    },

    //获取国家
    async getAllCountry() {
      let countryCode = (this.countryCode = this.$route.query.companyCountry
        ? this.$route.query.companyCountry
        : "");
      // localStorage.setItem('countryList',JSON.stringify(countryImgList))
      // 处理缓存问题
      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = "../../../../static/imagev2/zanwutupian.png";
            } else {
              countryImg = it.urlBanner.split("./../../../static")[1];
            }
            // let flag = require('../../static' + countryImg);
            let flag = "";
            try {
              flag = require("../../../../static" + countryImg);
            } catch (error) {
              countryImg = "../../../../static/imagev2/zanwutupian.png";
              // 提供一个默认值或者其他处理方式
              flag = require("../../../../static" + countryImg);
            }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      } else {
        // 清理缓存后重新请求页面
        let res = await getCountryCollection();
        if (res && res.code) {
          let countryImgList = res.data.rows;
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          ); //res.data.rows
          this.tabCountryList =
            JSON.parse(localStorage.getItem("countryList")) == null
              ? res.data.rows
              : JSON.parse(localStorage.getItem("countryList"));

          localStorage.setItem("countryList", JSON.stringify(countryImgList));
          let list = this.tabCountryList;

          list.forEach((item, index) => {
            item.countryList.forEach((it) => {
              let countryImg = "";
              if (it.urlBanner == null) {
                countryImg = "../../../../static/imagev2/zanwutupian.png";
              } else {
                countryImg = it.urlBanner.split("./../../../static")[1];
              }
              // let flag = require('../../static' + countryImg);
              let flag = "";
              try {
                flag = require("../../../../static" + countryImg);
              } catch (error) {
                countryImg = "../../../../static/imagev2/zanwutupian.png";
                // 提供一个默认值或者其他处理方式
                flag = require("../../../../static" + countryImg);
              }
              it.urlBanner = flag;
              if (countryCode && it.countryCode == countryCode) {
                this.countryName = it.nameEn;
                this.countryImg = it.urlBanner;
              }
            });
          });
        }
      }
    },

    //add compant弹框
    Add() {
      this.getAllCountry();
      this.countryImg = "";
      this.countryVal = "";
      this.searchName = "";
      this.addDialog = true;
      this.parentTable = [];
    },
    // 确定提交
    async submitAdd() {
      let id3a = this.addIndex == 2 ? this.id3a : this.id3a3;
      let companyCountry =
        this.addIndex == 2 ? this.companyCountry : this.companyCountry3;
      let params = "aaaId=" + id3a;
      let that = this;
      // getPdfPurchase(params).then(res => {
      //     // if (res.code) {
      //     let repordshow = res.data?.onlineReport?.type;
      //     if (repordshow != 1) {
      //         let type = that.addIndex;
      //         this.getOrdersAdd(type, 1).then(res => {
      //             if (res) {
      //                 this.geitadddate(id3a, companyCountry);
      //             }
      //         });
      //     } else {
      //         this.geitadddate(id3a, companyCountry);
      //     }
      //     // }
      // });
      this.geitadddate(id3a, companyCountry);
    },
    async geitadddate(id3a, companyCountry) {
      let CompanyName =
        this.addIndex == 2 ? this.companyNameEn : this.companyNameEn3;
      let CompanyNativeName =
        this.addIndex == 2 ? this.companyNameCn : this.companyNameCn3;
      let result = await getCompanyCompare(
        "id3a=" + id3a + "&companyCountry=" + companyCountry,
      );
      //解密
      // let data = JSON.parse(crypto.decrypt(result));
      let data = result;
      if (data && data.code) {
        let res = data.data;
        let obj = {
          aaaId: res.aaaId,
          CompanyName: CompanyName,
          CompanyNativeName: CompanyNativeName,
          LegalStatus: res.lables,
          LegalForm: res.legalForm,
          YearsinBusiness: res.yearsInBusiness,
          RegCapital: res.regCapital,
          isic: res.isic,
          IndustryDescription: res.industryDescription,
          Listed: res.listed,
          NoofEmployees: res.noOfEmployees,
          Noofshareholders: res.noOfShareholders,
          Revenue: res.revenue,
          Netincome: res.netIncome,
          TotalAssets: res.totalAssets,
          Profitmargin: res.profitMargin,
          Profitability: res.profitability,
          BlackList: res.blackList,
          status: res.status,
          CreditScore: res.creditScore,
        };
        if (this.addIndex == 2) {
          this.compObj2 = obj;
          this.isDelOne = false;
          this.lastView = true;
          //查看PDF状态
          // this.hasPdfPurchase(2);
        } else {
          this.compObj3 = obj;
          this.isDelTwo = false;
          this.lastView3 = true;

          //查看PDF状态
          // this.hasPdfPurchase(3);
        }
        this.addDialog = false;
      }
    },

    handleSelect(item) {
      this.searchName = item.company_name_en;
      this.addDisabled = false;

      this.countryObj = item;
      if (this.addIndex == 2) {
        this.id3a = item.aaa_id;
        this.companyCountry = item.company_country;
        this.companyNameCn = item.company_name;
        this.companyNameEn = item.company_name_en;
      } else {
        this.id3a3 = item.aaa_id;
        this.companyCountry3 = item.company_country;
        this.companyNameCn3 = item.company_name;
        this.companyNameEn3 = item.company_name_en;
      }
      this.submitAdd();
    },
    //删除添加
    delCompany() {
      if (this.addIndex == 2) {
        this.compObj2 = {};
        this.isDelOne = true;
        this.lastView = false;
        this.parentTable = [];
      } else {
        this.compObj3 = {};
        this.isDelTwo = true;
        this.lastView3 = false;
        this.parentTable = [];
      }
    },

    //  跳转公司详情
    ViewDetails(val) {
      let id3a = val == 2 ? this.id3a : this.id3a3;
      let companyCountry =
        val == 2 ? this.companyCountry : this.companyCountry3;
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let companyCountryEn = "";
      newscountry.map((item) => {
        if (item.countryCode == companyCountry) {
          companyCountryEn = item.dowjonesCountrycode;
        }
      });
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          id3a +
          "/background/snapshot?id3a=" +
          id3a +
          "&companyCountry=" +
          companyCountry +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });
      window.open(routeData.href, "_blank");
    },

    //step-1  获取 判断是否要扣点 线上报告,线下报告
    getPDFFile(val) {
      //有订单号吗
      if (!this.offlineOrderId) {
        let type = 2;
        this.getOrdersAdd(val, type).then((res) => {
          if (res) this.hanldPdfPurchase();
        });
      } else {
        this.hanldPdfPurchase();
      }
    },
    //step-3   1.查找订单；2.下载PDF
    async hanldPdfPurchase() {
      if (this.offlineOrderId) {
        await getPdfAddress(this.offlineOrderId).then((res) => {
          if (res && res.code) {
            window.open(res.data, "_blank");
          } else {
            this.$message({
              message:
                "It normally takes 2-4 days to deliver,this updated rerpot.",
              duration: 5000,
            });
          }
        });
      }
    },
    //step-2 是否购买PDF,获取订单号
    async hasPdfPurchase(val) {
      let id3a = val == 2 ? this.id3a : this.id3a3;
      let params = "aaaId=" + id3a;
      await getPdfPurchase(params).then(async (res) => {
        if (res && res.code) {
          if (res.data.offlineReport) {
            this.offlineOrderId = res.data.offlineReport.id;
            this.orderStatus = res.data.offlineReport.orderStatus;
            if (this.orderStatus == "4") {
              if (val == 2) {
                this.updateDisabled = true;
              } else {
                this.updateDisabled3 = true;
              }
            } else {
              if (val == 2) {
                this.updateDisabled = false;
              } else {
                this.updateDisabled3 = false;
              }
            }
          }
        } else {
          if (val == 2) {
            this.updateDisabled = false;
          } else {
            this.updateDisabled3 = false;
          }
        }
      });
    },
    /**
     *用户购买报告 "type": 1 线下，2 线上, 13 Import/Export
     */
    async getOrdersAdd(val, type) {
      let id3a = val == 2 ? this.id3a : this.id3a3;
      let companyCountry =
        val == 2 ? this.companyCountry : this.companyCountry3;
      let companyName = val == 2 ? this.companyNameEn : this.companyNameEn3;
      //1  :线上报告
      let params = {
        companyName: companyName, //必须
        aaaId: id3a, //必须
        companyCountry: companyCountry, //必须
        method: "0", //支付方式  0：帐号余额 1：支付宝 2：微信 ，3 国际万事达卡 支付 传  0   //必须
        methodType: "0", //支付类型： 1 免费额度 ，0 充值额度       //(非必须)
        type: type, //订单类型 //必须
      };
      let status = "";

      await ordersAdd(params).then((result) => {
        let data = result;
        if (data && data.code) {
          // this.hasPdfPurchase(val);
          status = true;
          this.$message({
            message: data.msg,
            type: "success",
            // duration: 5000,
          });
        } else {
          this.$message({
            message: data.msg,
            type: "error",
            // duration: 5000,
          });
          let that = this;
          let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;

          let routeData = "";
          setTimeout(function () {
            if (userinfo.type == "3") {
              routeData = that.$router.resolve({
                path: "/account/quota",
              });
            } else {
              routeData = that.$router.resolve({
                path: "/account/addCredit",
              });
            }

            window.open(routeData.href, "_blank");
          }, 2000);

          status = false;
        }
      });
      return status;
    },
  },
};
</script>
<style scoped lang="less">
.sel_coun {
  position: relative;
}

.country_img {
  position: absolute;
  top: 0.2857142857142857rem;
  left: 0.2857142857142857rem;
  z-index: 8;
}

.country_img img {
  width: 3.2857142857142856rem;
  height: 2.2857142857142856rem;
}

.el-select,
.el-autocomplete {
  width: 100%;
}

.create_item /deep/ .el-input__inner {
  width: 100%;
  height: 2.857142857142857rem;
  border-radius: 0.5714285714285714rem;
  border: 0.07142857142857142rem solid #8497ab;
}

.country_sel /deep/ .el-input__inner {
  padding-left: 3.9285714285714284rem;
}

.create_item /deep/ .el-autocomplete .el-input__inner {
  background-size: 1.4285714285714286rem;
  background-repeat: no-repeat;
  background-position: 98%;
  padding-right: 4.285714285714286rem;
}

.create_item {
  margin-bottom: 1.4285714285714286rem;
}

.cop_title {
  display: flex;
  align-items: center;
  font-size: 1.4285714285714286rem;
  font-family: "Arial Bold";

  background-color: #fff;
}

.cop_cont_head {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2.857142857142857rem;
  background: #f2f5f9;
  color: #8497ab;
  font-size: 1.2857142857142858rem;
}

.cop_company {
  width: 26%;
  line-height: 2.7142857142857144rem;
  color: #1a2332;
  font-family: "Arial Bold";
}

.cop_companyfirst {
  width: 23.5%;
}

.cop_add {
  height: 2.857142857142857rem;
  cursor: pointer;
  position: absolute;
}

.cop_add .flex_center {
  height: 2.857142857142857rem;
}

.cop_add_ic {
  background: #009ea7;
}

.cop_del_ic {
  background: #f56b6b;
}

.cop_del_ic,
.cop_add_ic {
  width: 1.5714285714285714rem;
  height: 1.5714285714285714rem;
  background-repeat: no-repeat;
  background-size: 0.7142857142857143rem;
  background-position: center;
  border-radius: 50%;
  margin-right: 0.5714285714285714rem;
}

.cop_cont_box {
  position: relative;
  background: #ffffff;
}

.cop_cont_cont .item {
  display: flex;
  align-items: center;
  padding: 0.5714285714285714rem;
  font-size: 1.2857142857142858rem;
  height: 4.571428571428571rem;
  line-height: 1.7142857142857142rem;
  border-bottom: 0.07142857142857142rem solid #e7eaed;
}

.cop_cont_cont .list.title .item {
  // width: 20rem;
  overflow: hidden;
  padding: 0.5714285714285714rem 1.4285714285714286rem;
  color: #1a2332;
  font-family: "Arial Bold";
}

.cop_cont_cont .list.content {
  width: 27%;
}

.cop_cont_cont .list.content.last {
  width: 19rem;
}

.line_2 .c_d_tag {
  width: 17.5rem;
}

.c_d_tag .el-tag {
  height: 1.8571428571428572rem;
  line-height: 1.8571428571428572rem;
  background: #ffffff;
  border-radius: 0.5714285714285714rem;
  border: 0.07142857142857142rem solid #ff7600;
  font-size: 0.8571428571428571rem;
  color: #ff7600;
  margin: 0 0.2857142857142857rem 0.14285714285714285rem;
}

.btn_box {
  margin-top: 2.142857142857143rem;
}

.btn_return {
  width: 10rem;
  height: 2.857142857142857rem;
  line-height: 2.857142857142857rem;
  background: #e7eaed;
  border-radius: 0.8571428571428571rem;
  font-size: 1.1428571428571428rem;
  color: #022955;
}

.create_item_lab {
  font-size: 1.1428571428571428rem;
  color: #022955;
  margin-bottom: 0.5714285714285714rem;
}

.create_inpt {
  width: 100%;
  height: 3.2857142857142856rem;
  background: #ffffff;
  border-radius: 0.8571428571428571rem;
  border: 0.07142857142857142rem solid #e7eaed;
  font-size: 1.1428571428571428rem;
  padding: 0.9285714285714286rem 1.4285714285714286rem;
  margin-bottom: 1.4285714285714286rem;
}

.btn_view {
  padding: 0.5714285714285714rem 0.42857142857142855rem;
  background: #edf9ff;
  border-radius: 0.8571428571428571rem;
  border: 0.07142857142857142rem solid #009ea7;
  color: #009ea7;
  height: 2.4285714285714284rem;
  line-height: 1.2857142857142858rem;
  font-size: 1rem;
}

.btn_view + .btn_view {
  margin-left: 0.5714285714285714rem;
}

.name_ser {
  position: relative;
}

.ser_icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 4.285714285714286rem;
  height: 2.857142857142857rem;
}

.btn_gray,
.btn_blue {
  width: 10rem;
  height: 2.4285714285714284rem;
  line-height: 2.4285714285714284rem;
  background: #009ea7;
  border-radius: 0.8571428571428571rem;
  font-size: 1rem;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
}

.btn_gray,
.btn_blue:disabled {
  color: #8497ab;
  background: #e7eaed;
}

.btn_gray {
  margin-left: 0.7142857142857143rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.el-radio__inner {
  width: 1.4285714285714286rem;
  height: 1.4285714285714286rem;
}

/* 搜索 */
.head_search {
  height: 3.857142857142857rem;
  background: #ffffff;
  border: 0.07142857142857142rem solid #cccccc;
  color: #022955;
}

.search_right {
  flex: 1;
  position: relative;
}

.search_input {
  width: 100%;
  word-wrap: break-word;
  line-height: 2.142857142857143rem;
  outline: none;
  border: none;
  font-size: 1.14285714rem;
}

.search_btn {
  width: 2.857142857142857rem;
  height: 3.857142857142857rem;
  cursor: pointer;
}

.search_btn img {
  width: 1.7142857142857142rem;
}

/* 选择下拉 */
.search_left {
  width: 17.142857142857142rem;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.search_left::after {
  content: "";
  position: absolute;
  right: 0;
  top: 1.2142857142857142rem;
  width: 0.07142857142857142rem;
  height: 1.4285714285714286rem;
  background-color: #e7eaed;
}

.search_left /deep/ .el-input__inner {
  border: none;
  font-size: 1.1428571428571428rem;
}

/deep/ .el-input__inner {
  padding-right: 0rem !important;
}

.country_flag {
  display: flex;
  align-items: center;
}

.country_flag_img {
  width: 2.5714285714285716rem;
  height: 1.5714285714285714rem;
  margin: 1.0714285714285714rem 0.14285714285714285rem 1.0714285714285714rem
    1.0714285714285714rem;
  box-shadow: 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem
    rgba(0, 0, 0, 0.2);
}

.sel_value {
  width: 4.571428571428571rem;
  font-size: 1rem;
  word-break: break-all;
}

.search_left .el-select {
  position: absolute;
  top: 0;
  width: 17.428571428571427rem;
}

.search_left /deep/ .el-select .el-input__inner {
  background-color: transparent;
  height: 3.7142857142857144rem;
  /* opacity: 0; */
  font-size: 1.1428571428571428rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search_left.on /deep/ .el-select .el-input__inner {
  padding-left: 4.285714285714286rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.head_pro_cas /deep/ .el-input__inner::placeholder,
.search_left /deep/ .el-select .el-input__inner::placeholder {
  color: #022955;
}

.head_pro_cas /deep/ .el-icon-arrow-down:before,
.search_left /deep/ .el-select .el-icon-arrow-up:before {
  color: #8497ab !important;
}

.sel_place {
  width: 100%;
  line-height: 3.7142857142857144rem;
  padding-left: 1.4285714285714286rem;
  display: inline-block;
  font-size: 1rem;
}

.el-select-dropdown__wrap {
  max-height: 26.785714285714285rem !important;
}

.el-select-dropdown__list {
  padding: 0.7142857142857143rem 0 !important;
}

.search_sel_container {
  width: 85.71428571428571rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left {
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 0.07142857142857142rem;
  background-color: #eee;
}

.head_swi_keyword {
  position: relative;
}

.head_swi_keyword .el-switch,
.head_login .el-switch {
  height: 2.4285714285714284rem;
  line-height: 2.4285714285714284rem;
}

.head_swi_keyword /deep/ .el-switch__core,
.head_login /deep/ .el-switch__core {
  width: 7rem !important;
  height: 2.4285714285714284rem;
  background: #006a9a;
  box-shadow: inset 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem
    #054562;
  border-radius: 1.2142857142857142rem;
  border: none;
}

.head_swi_keyword /deep/ .el-switch__core {
  width: 7.142857142857143rem !important;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core {
  background: #ff7600;
  box-shadow: inset 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem
    #aa4f00;
}

.head_swi_keyword /deep/ .el-switch__core:after,
.head_login /deep/ .el-switch__core:after {
  top: 0.21428571428571427rem;
  left: 0.21428571428571427rem;
  width: 2rem;
  height: 2rem;
  background: #ffffff;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
  left: 6.142857142857143rem;
}

.search_sel_container /deep/ .el-tabs__active-bar {
  display: none;
}

.search_sel_container .right {
  width: 68.5rem;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-height: 24.285714285714285rem;
  align-content: flex-start;
  margin-right: 0.07142857142857142rem;
  padding: 0 0.8571428571428571rem;
  overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
  height: 3rem;
  display: flex;
  align-items: center;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
  background: #f5f5f5;
}

.el-select-dropdown__item:hover {
  background: #f5f5f5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
  color: #009ea7;
  font-weight: normal;
}

.search_sel_container .left_txt {
  font-size: 14px;
  margin-right: 10px;
}

.search_sel_container .right .el-select-dropdown__item {
  width: 15.857142857142858rem;
  height: 4rem;
  padding: 0 0.7142857142857143rem;
  margin: 0.3542857142857143rem 0.35714285714285715rem;
  border: 0.07142857142857142rem solid #fff;
  background: #f5f5f5;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
  background: #f5f5f5;
  border: 1px solid #009ea7;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
  color: #022955;
  font-weight: normal;
}

.right_item {
  height: 100%;
  width: 100%;
}

.search_sel_container .right .img {
  width: 3.857142857142857rem;
  height: 100%;
  margin-right: 0.35714285714285715rem;
}

.search_sel_container .right .rBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search_sel_container .right .rBox .coun_title {
  font-size: 1.1428571428571428rem;
  line-height: 1;
  margin-bottom: 0.2857142857142857rem;
  max-width: 10rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.table_box /deep/ .el-table__empty-block .el-table__empty-text {
  width: auto;
}

.list-title {
  width: 25%;
}

.CompanyNameActive {
  font-size: 1.2857142857142858rem;
  color: #009ea7 !important;
}

.el-select /deep/ .el-input__suffix {
  right: 1rem !important;
}

.content {
  padding: 0rem;
  margin: 0rem !important;
}

.flex_center {
  justify-content: flex-start;
}

.contentone .item {
  padding-left: 1.4285714285714286rem !important;
}

.item_active {
  background: #f2f5f9;
  height: 50px !important;
  position: relative;
}
.contentone .item {
  background: #f2f5f9;
}
</style>
